import { Box, Chip, ChipProps } from '@mui/material';

export function Tags(p: {
  tags: readonly string[];
  size?: ChipProps['size'];
  onClick?: (tag: string, event: React.MouseEvent<HTMLDivElement>) => void;
}) {
  return (
    <Box sx={{ display: 'inline-flex', gap: 0.5, flexWrap: 'wrap' }}>
      {p.tags.map((tag) => (
        <Chip
          key={tag}
          label={tag}
          size={p.size}
          variant="outlined"
          onClick={p.onClick ? (event) => p.onClick?.(tag, event) : undefined}
        />
      ))}
    </Box>
  );
}
